import axios from './axiosInstances/privateAxiosInstance';

export const tableauJwToken = async (): Promise<string> => {
  try {
    const response: string = await axios.get('/qr/interactive/getJwtGenerationToken');
    return response;
  } catch (error) {
    throw new Error('Failed to fetch token');
  }
};
